const config = {
  appUrl: 'https://edge01.fleet-pulse.com',
  growthBookSdkClientKey: 'sdk-4hwOMnOq1ZH4o2ZC',
};

export default config;
